import React from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2'


export default function Contact() {

  // eslint-disable-next-line no-unused-vars
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "5b423c3e-d506-4924-b8e1-7c7e8f1f3c27");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      Swal.fire({
        title: "Success!",
        text: "Your Message has been sent successfully !",
        icon: "success"
      });
      event.target.reset();
    } else {
      console.log("Error", data);
      Swal.fire({
        title: "Oops...",
        text: "Something went wrong! Please try again later",
        icon: "error"
      });
    }
  };



  return (
    <>
      <div className="page-title light-background">
        <div className="container d-lg-flex justify-content-between align-items-center">
          {/* <h1 className="mb-2 mb-lg-0">Product Category</h1> */}
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li className="current">Contact</li>
            </ol>
          </nav>
        </div>
      </div>

      <section id="contact" className="contact section">
        <div
          className="container aos-init aos-animate"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="row gy-4">
            <div className="col-lg-4">
              <div
                className="info-item d-flex aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <i className="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h3>Address</h3>
                  <p>
                    No. 16, Jay sardar estate, st. no. 3,Ramnath ind. zone,
                    B/h Murlidhar way bridge National highway,Rajkot - 360002.
                  </p>
                </div>
              </div>

              <div
                className="info-item d-flex aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <i className="bi bi-telephone flex-shrink-0"></i>
                <div>
                  <h3>Call Us</h3>
                  <p>
                    +91 96029 60239 | +91 99675 68868

                  </p>
                </div>
              </div>

              <div
                className="info-item d-flex aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <i className="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h3>Email Us</h3>
                  <p>railingworld08@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="col-lg-8">

              <form onSubmit={onSubmit} className="php-email-form aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                  </div>
                  <div className="col-md-6">
                    <input type="email" className="form-control" name="email" placeholder="Your Email" required />
                  </div>
                  <div className="col-md-12">
                    <input type="text" className="form-control" name="subject" placeholder="Subject" required />
                  </div>
                  <div className="col-md-12">
                    <textarea className="form-control" name="message" rows="6" placeholder="Message" required></textarea>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit">Send Message</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            className="mt-5 mb-4 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <iframe
              style={{ border: 0, width: '100%', height: '270px' }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29542.18133959547!2d70.79272905329124!3d22.2487025917505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959b5eae238d07f%3A0xfd0c6146ed870852!2sMetro%20Steel!5e0!3m2!1sen!2sin!4v1749494532485!5m2!1sen!2sin"
              frameBorder="0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>
          </div>


        </div>
      </section>

    </>
  )
}